<template>
  <m-iframe :src="helpCenterURL" :lazy="false" />
</template>

<script lang="ts">
import {computed, defineComponent} from '@vue/composition-api'

import MIframe from '@/components/atom/MIframe.vue'
import {mapGetters} from '@/utils/map-store'

export default defineComponent({
  name: 'HelpCenter',
  components: {MIframe},
  setup(props, {root}) {
    const {getBranch: branch} = mapGetters(root.$store.getters)

    const helpCenterURL = computed(() => {
      switch (branch.value) {
        case 'PT':
          return 'https://mapit.me/pt-pt/perguntas-frequentes-do-revendedor/'
        case 'ES':
        default:
          return 'https://mapit.me/preguntas-frecuentes-concesionarios'
      }
    })

    return {
      helpCenterURL,
    }
  },
})
</script>
<style scoped>
.my-iframe {
  border: 0;
  padding: 0;
  margin: 0;
}
</style>
